
export const getLocalDateTimeString = (timestamp?: number) => {
    const date = timestamp ? new Date(timestamp) : new Date();
    const offset = date.getTimezoneOffset() * 60000;
    const localDate = new Date(date.getTime() - offset);
    return localDate.toISOString().slice(0, 16);
};

export const checkDate = (timestamp: number, type: 'today' | 'yesterday' | '3days' | 'week' | 'month' | 'all') => {
    if (type === 'all') return true;
    const getBJMidnight = (ts: number) => {
        const dateStr = new Date(ts).toLocaleString('en-US', {timeZone: 'Asia/Shanghai'});
        const d = new Date(dateStr);
        d.setHours(0,0,0,0);
        return d;
    };
    const today = getBJMidnight(Date.now());
    const target = getBJMidnight(timestamp);
    const diffDays = Math.floor((today.getTime() - target.getTime()) / (1000 * 60 * 60 * 24));
    if (type === 'today') return diffDays === 0;
    if (type === 'yesterday') return diffDays === 1;
    if (type === '3days') return diffDays <= 2; 
    if (type === 'week') return diffDays <= 6;
    if (type === 'month') return diffDays <= 29;
    return true;
};

export const compressImage = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target?.result as string;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const MAX_WIDTH = 2560; 
                let width = img.width;
                let height = img.height;
                if (width > MAX_WIDTH) { height *= MAX_WIDTH / width; width = MAX_WIDTH; }
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                if (!ctx) { resolve(img.src); return; }
                
                ctx.imageSmoothingEnabled = true;
                ctx.imageSmoothingQuality = 'high';
                ctx.drawImage(img, 0, 0, width, height);
                resolve(canvas.toDataURL('image/jpeg', 0.95));
            };
            img.onerror = (err) => reject(err);
        };
        reader.onerror = (err) => reject(err);
    });
};
